import Image from 'next/image';
import type { ImageIconProps } from './types';

export const IconSpotify = ({ width, height, className }: ImageIconProps) => {
  return (
    <Image
      src='/images/ui/icons/spotify.svg'
      width={width}
      height={height}
      alt='Spotify'
      className={className}
    />
  );
};
